import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';
import shadows from 'theme/atoms/shadows';
import * as Buttons from 'theme/components/Buttons.style';

export const Dropdown = styled('div')`
  background-color: ${colours.warning[500]};
  border-radius: 100px;
  cursor: default;
  display: flex;
  flex-direction: column;
  gap: 15px;
  position: relative;
`;

export const DropdownButton = styled(Buttons.SecondaryDark)`
  background-color: ${colours.warning[500]};
  border-radius: 100px;
  color: ${colours.neutral[900]};
  justify-content: space-between;

  svg path {
    stroke: ${colours.neutral[900]};
  }

  @media (max-width: ${breakpoints.tablet}) {
    flex: 1 1 100%;
    max-height: unset;
    max-width: 100%;
    width: 100%;
  }

  &:hover {
    background-color: ${colours.warning[400]};
  }

  &:focus {
    background-color: ${colours.warning[400]};
  }

  &:active {
    background-color: ${colours.warning[400]};
  }
`;

export const StatusDropdown = styled('div')`
  background-color: ${colours.neutral[100]};
  border: 0.5px solid ${colours.neutral[300]};
  border-radius: 20px;
  box-shadow: ${shadows.XL};
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 20px 20px 20px 20px;
  position: absolute;
  right: 0;
  top: 50px;
  width: fit-content;
  z-index: 50;
`;

export const DropdownCategory = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const DropdownSelection = styled('div')`
  align-items: center;
  background-color: white;
  border-radius: 20px;
  cursor: pointer;
  display: flex;
  gap: 10px;
  padding: 10px 20px;
  white-space: nowrap;
  width: fit-content;

  @media (max-width: ${breakpoints.tablet}) {
    padding: 15px 25px;
  }
`;

export const SelectionNeutral = styled(DropdownSelection)`
  background-color: ${colours.neutral[400]};

  p {
    color: ${colours.neutral[900]};
  }

  svg path {
    stroke: ${colours.neutral[900]};
  }

  &:hover {
    background-color: ${colours.neutral[800]};

    p {
      color: white;
    }

    svg path {
      stroke: white;
    }
  }
`;

export const SelectionYellow = styled(DropdownSelection)`
  background-color: ${colours.warning[500]};

  p {
    color: ${colours.warning[900]};
  }

  svg path {
    stroke: ${colours.warning[900]};
  }

  &:hover {
    background-color: ${colours.warning[800]};

    p {
      color: white;
    }

    svg path {
      stroke: white;
    }
  }
`;

export const SelectionGreen = styled(DropdownSelection)`
  background-color: ${colours.success[500]};

  p {
    color: ${colours.success[900]};
  }

  svg path {
    stroke: ${colours.success[900]};
  }

  &:hover {
    background-color: ${colours.success[700]};

    p {
      color: white;
    }

    svg path {
      stroke: white;
    }
  }
`;

export const StatusDecoration = styled('div')`
  border-radius: 30px;
  height: 10px;
  width: 10px;
`;

export const NeutralDecoration = styled(StatusDecoration)`
  background-color: ${colours.neutral[200]};
`;

export const YellowDecoration = styled(StatusDecoration)`
  background-color: ${colours.warning[200]};
`;

export const GreenDecoration = styled(StatusDecoration)`
  background-color: ${colours.success[200]};
`;
